import lenders, { getLenders } from './lenders';

export default lenders;
export {
  getLenders,
};
